<template>
  <v-item class="option-list-item pa-3 mb-2" :value="value">
    <template #default="{ active, toggle }">
      <v-hover v-slot="{ hover }">
        <div :class="getClass(active, hover)" @click="toggle">
          <div class="subtitle-2 font-weight-bold">
            <slot></slot>
          </div>
          <div class="caption">
            <slot name="caption"></slot>
          </div>
        </div>
      </v-hover>
    </template>
  </v-item>
</template>

<script>
export default {
  name: 'OptionListItem',
  props: {
    value: {
      type: [Object, String, Number, Array],
      required: true,
    },
  },
  methods: {
    getClass(active, hover) {
      return {
        ['grey lighten-5']: !active && hover,
        ['grey lighten-4']: !active && !hover,
        ['primary white--text']: active,
        ['grey--text']: !active,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.option-list-item {
  cursor: pointer;
}
</style>
